import {
  generateCountryText,
  generatePeriodText,
  ParserType,
  TRANSACTION_AMOUNT_DICTIONARY,
} from "./common";

import type { RiskRuleNumberOfTransactionsAlias } from "../../models/RiskRule";

export const numberOfTransactionsParser: ParserType<
  RiskRuleNumberOfTransactionsAlias
> = (rule, bankName) => {
  const { payload, filter, operator } = rule;
  const baseTextPart = "The total initiated transactions";

  const countryTextPart = generateCountryText({ filter, bankName });
  const periodTextPart = generatePeriodText({ payload });
  const conditionTextPart = generateConditionText({ operator, payload });

  return [
    baseTextPart,
    countryTextPart,
    periodTextPart,
    conditionTextPart,
  ].join("");
};

const generateConditionText = ({
  operator,
  payload,
}: Pick<RiskRuleNumberOfTransactionsAlias, "operator" | "payload">) => {
  const operatorTranslated = TRANSACTION_AMOUNT_DICTIONARY[operator];

  return ` was ${operatorTranslated}\xa0${payload.value}`;
};
